<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <v-form ref="add_form" @submit.prevent="createCash">
          <div class="pa-3">
            <div>
              <v-radio-group v-model="addCash.type_user">
                <div class="d-flex">
                  <div class="d-flex mr-1">
                    <div>
                      <v-radio color="#86bc3a" value="1" @click="clear_address"></v-radio>
                    </div>
                    <div>บุคคลธรรมดา</div>
                  </div>
                  <div class="d-flex ml-1">
                    <div>
                      <v-radio color="#86bc3a" value="2"></v-radio>
                    </div>
                    <div>นิติบุคคล</div>
                  </div>
                </div>
              </v-radio-group>
            </div>
            <div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-account</v-icon>
                    <div class="ml-1">รหัสลูกค้า : {{ addCash.id }}</div>
                  </div>
                </div>
                <div class="mt-3 ml-1">
                  <div class="d-flex align-center">
                    <v-checkbox color="#86bc3a" class="ma-0" v-model="addCash.clinics_ck" hide-details="auto"></v-checkbox>
                    <div>
                      ลูกค้าคลีนิค
                    </div>
                  </div>
                </div>

                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อ - สกุล *" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" :autofocus="focus_input" hide-details="auto" required v-model="addCash.name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="เบอร์โทรสำหรับเข้าสู่ระบบ *" type="tel" maxlength="11" :rules="phoneRules" @keypress="isNumber($event, addCash.telephone)" prepend-inner-icon="mdi-phone-outline" hide-details="auto" v-model="addCash.telephone" required outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="อีเมล" type="email" @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline" hide-details="auto" v-model="addCash.email" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="เลขเสียภาษี" type="tel" maxlength="13" @keypress="isTaxNumber($event, addCash.tax_number)" prepend-inner-icon="mdi-card-account-details-outline" hide-details="auto" v-model="addCash.tax_number" outlined></v-text-field>
                </div>

              </div>
              <div class="grid_full">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-home</v-icon>
                    <div class="ml-1">ที่อยู่ในการจัดส่ง</div>
                  </div>
                </div>
              </div>
              <div class="display_pc">
                <div class="grid_half">
                  <div class="mt-4 ml-1">บ้านเลขที่/ที่อยู่</div>
                  <div class="mt-4 ml-1">
                    <div class="d-flex align-center">
                      <v-checkbox color="#86bc3a" class="ma-0" v-model="addCash.chiang_mai_cod" hide-details="auto"></v-checkbox>
                      <div class="mr-3">
                        ส่งฟรีในเชียงใหม่
                      </div>
                      <v-checkbox color="#86bc3a" class="ma-0" v-model="addCash.customer_paylater" hide-details="auto"></v-checkbox>
                      <div class="ml-1">ส่งก่อนจ่ายเงินทีหลัง</div>
                    </div>
                  </div>
                </div>
                <div class="grid_full">
                  <div class="mt-0">
                    <v-text-field class="mt-2 mr-1" color="#86bc3a" placeholder="บ้านเลขที่/ที่อยู่" hide-details="auto" required v-model="addCash.address" outlined></v-text-field>
                  </div>
                </div>
              </div>
              <div class="display_mobile">
                <div class="grid_full">
                  <div class="mt-4 ml-1">
                    <div class="d-flex align-center">
                      <v-checkbox color="#86bc3a" class="ma-0" v-model="addCash.chiang_mai_cod" hide-details="auto"></v-checkbox>
                      <div>ส่งฟรีในเชียงใหม่</div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                    <v-text-field class="mt-2 mr-1" color="#86bc3a" label="บ้านเลขที่/ที่อยู่" hide-details="auto" required v-model="addCash.address" outlined></v-text-field>
                  </div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <addressinput-subdistrict :store="mainDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="addCash.sub_district"/>
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-district :store="mainDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="addCash.district"/>
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-province :store="mainDataStore" class="custom_css" placeholder="จังหวัด" v-model="addCash.province" />
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-zipcode numbered type="number" :store="mainDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="addCash.postcode"/>
                </div>
              </div>
              <div v-if="addCash.type_user === '2'">
                <div class="grid_full">
                  <div class="mt-3">ที่อยู่ในการออกเอกสาร</div>
                  <v-radio-group v-model="addCash.delivery_type">
                    <div class="d-flex">
                      <div class="d-flex mr-1">
                        <div>
                          <v-radio color="#86bc3a" value="0" @click="duplicate_address"></v-radio>
                        </div>
                        <div>เหมือนกัน</div>
                      </div>
                      <div class="d-flex ml-1">
                        <div>
                          <v-radio color="#86bc3a" value="1" @click="unduplicate_address"></v-radio>
                        </div>
                        <div>ไม่เหมือนกัน</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
                <div v-if="addCash.delivery_type === '1'">
                  <div class="grid_full">
                    <div class="mt-3">
                      <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                      <v-text-field class="mt-2 mr-1" color="#86bc3a" placeholder="บ้านเลขที่/ที่อยู่" hide-details="auto" required v-model="addCash.address_delivery" outlined></v-text-field>
                    </div>
                  </div>
                  <div class="grid_half">
                    <div class="mt-3 mr-1">
                      <addressinput-subdistrict :store="subDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="addCash.sub_district_delivery"/>
                    </div>
                    <div class="mt-3 mr-1">
                      <addressinput-district :store="subDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="addCash.district_delivery"/>
                    </div>
                    <div class="mt-3 mr-1">
                      <addressinput-province :store="subDataStore" class="custom_css" placeholder="จังหวัด" v-model="addCash.province_delivery" />
                    </div>
                    <div class="mt-3 mr-1">
                      <addressinput-zipcode numbered :store="subDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="addCash.postcode_delivery"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <v-btn height="45" class="white--text grad-success-bg btn_mobile" style="font-size: 18px" type="submit">บันทึกข้อมูล</v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/axios.js'
import Swal from 'sweetalert2'
import { DataStore,  } from 'vue-thailand-address';
import {isTelephone, onPaste, taxNumber, validateEmail} from "@/js/handler";
const mainDataStore = new DataStore();
const subDataStore = new DataStore();

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      mainDataStore,
      subDataStore,
      checkbox: false,
      loading_page: false,
      name: null,
      focus_input: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      phoneRules: [v => ( v.length > 8 ) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      taxRules: [v => ( v.length === 13 ) || "เลขเสียภาษีไม่ถูกต้อง !",],
      addCash: {
        id: null,
        type_user: '1',
        delivery_type: '1',
        clinics_ck: 0,
        chiang_mai_cod: 0,
        customer_paylater:0,
        name: null,
        telephone: '',
        email: '',
        tax_number: '',
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null,
        address_delivery: null,
        sub_district_delivery: null,
        district_delivery: null,
        province_delivery: null,
        postcode_delivery: null,
      },
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
          .then(() => {
            this.$router.push('/customer');
          });
    },
    duplicate_address() {
      if (this.addCash.type_user === '2' && this.addCash.delivery_type === '0'){
        this.addCash.address_delivery = this.addCash.address;
        this.addCash.sub_district_delivery = this.addCash.sub_district;
        this.addCash.district_delivery = this.addCash.district;
        this.addCash.province_delivery = this.addCash.province;
        this.addCash.postcode_delivery = this.addCash.postcode;
      }
    },
    unduplicate_address() {
      this.addCash.address_delivery = null;
      this.addCash.sub_district_delivery = null;
      this.addCash.district_delivery = null;
      this.addCash.province_delivery = null;
      this.addCash.postcode_delivery = null;
    },
    clear_address() {
      this.addCash.address_delivery = null;
      this.addCash.sub_district_delivery = null;
      this.addCash.district_delivery = null;
      this.addCash.province_delivery = null;
      this.addCash.postcode_delivery = null;
    },
    createCash() {
      if (this.addCash.type_user === '2' && this.addCash.delivery_type === '0') {
        this.addCash.address_delivery = this.addCash.address;
        this.addCash.sub_district_delivery = this.addCash.sub_district;
        this.addCash.district_delivery = this.addCash.district;
        this.addCash.province_delivery = this.addCash.province;
        this.addCash.postcode_delivery = this.addCash.postcode;
      }
      if (this.$refs.add_form.validate()) {
        if (this.addCash.name !== null && this.addCash.telephone !== null) {
          let data = {
            customer_type: 1,
            // delivery_type: this.addCash.delivery_type, //เพิ่ม 1 field
            clinics: this.addCash.clinics_ck, //เพิ่ม 1 field
            is_deliveryfreecnx: this.addCash.chiang_mai_cod,
            customer_status: this.addCash.type_user,
            name: this.addCash.name,
            telephone: this.addCash.telephone,
            email: this.addCash.email,
            customer_personal_id: this.addCash.tax_number,
            customer_paylater:this.addCash.customer_paylater,
            address: this.addCash.address,
            sub_district: this.addCash.sub_district,
            district: this.addCash.district,
            province: this.addCash.province,
            postcode: this.addCash.postcode,
            address_delivery: this.addCash.address_delivery,
            sub_district_delivery: this.addCash.sub_district_delivery,
            district_delivery: this.addCash.district_delivery,
            province_delivery: this.addCash.province_delivery,
            postcode_delivery: this.addCash.postcode_delivery,
            is_delivery_same_address: this.addCash.delivery_type,
            status: 1,            
          }
          if(this.addCash.type_user == 2){
            data = {
              customer_type: 1,
              // delivery_type: this.addCash.delivery_type, //เพิ่ม 1 field
              clinics: this.addCash.clinics_ck, //เพิ่ม 1 field
              is_deliveryfreecnx: this.addCash.chiang_mai_cod,
              customer_paylater: this.addCash.customer_paylater,
              customer_status: this.addCash.type_user,
              name: this.addCash.name,
              telephone: this.addCash.telephone,
              email: this.addCash.email,
              customer_personal_id: this.addCash.tax_number,
              address: this.addCash.address,
              sub_district: this.addCash.sub_district,
              district: this.addCash.district,
              province: this.addCash.province,
              postcode: this.addCash.postcode,
              address_delivery: this.addCash.delivery_type == 1 ? this.addCash.address_delivery : this.addCash.address,
              sub_district_delivery: this.addCash.delivery_type == 1 ? this.addCash.sub_district_delivery : this.addCash.sub_district,
              district_delivery: this.addCash.delivery_type == 1 ? this.addCash.district_delivery : this.addCash.district,
              province_delivery: this.addCash.delivery_type == 1 ? this.addCash.province_delivery : this.addCash.province,
              postcode_delivery: this.addCash.delivery_type == 1 ? this.addCash.postcode_delivery : this.addCash.postcode,
              is_delivery_same_address: this.addCash.delivery_type,
              status: 1,            
            }            
          }
          HTTP.post('/customers/create', data).then((res) => {
            if (res.data.success === true) {
              this.addCash.delivery_type = null
              this.addCash.telephone = null
              this.addCash.chiang_mai_cod = null
              this.addCash.customer_paylater = null
              this.addCash.email = null
              this.addCash.tax_number = null
              this.addCash.address = null
              this.addCash.sub_district = null
              this.addCash.district = null
              this.addCash.province = null
              this.addCash.postcode = null
              this.addCash.address_delivery = null
              this.addCash.sub_district_delivery = null
              this.addCash.district_delivery = null
              this.addCash.province_delivery = null
              this.addCash.postcode_delivery = null
              this.$refs.add_form.resetValidation()
              this.createAlert()
            }
            else {
              Swal.fire({
                title: 'ไม่สามารถดำเนินการได้ !',
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.addCash.telephone = ''
              })
            }
          })
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'กรุณากรอกข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.$refs.add_form.validate()
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.add_form.validate()
        })
      }
    },
    genIdCode() {
      HTTP.post('/customers/getcusid')
          .then((res) => {
            if (res.data.success === true){
              this.addCash.id = res.data.object;
            }
          })
    },
  },
  mounted() {
    this.genIdCode();
  },
}
</script>

<style scoped>
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.display_pc {
  display: grid;
}
.display_mobile {
  display: none;
}
@media only screen and (max-width: 500px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: grid;
  }
}
</style>
